module.exports = "/layout/app/images/logo-payment-paypal.165ad8dc.svg";